// components/models/GrokImagineControlPanel.tsx
import React, { useCallback, memo } from 'react';
import AutoGrowingTextarea from '../AutoGrowingTextarea';
import { GrokImagineParams } from '#types/types';
import { useKernel } from '@/kernel/Kernel';
import { useKernelStore } from '@/kernel/kernelStores';

export const getDefaultGrokImagineParams = (): GrokImagineParams => ({
  prompt: '',
  num_images: 1,
  aspect_ratio: '1:1',
  output_format: 'jpeg',
  sync_mode: false,
  seed: -1,
});

const GrokImagineControlPanel: React.FC = () => {
  const { kernel } = useKernel();
  const params = useKernelStore(
    state => state.modelParams[state.diffusionModel] as GrokImagineParams | undefined
  );

  const handleParamChange = useCallback((
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const diffusionModel = kernel.current?.getDiffusionModel();
    if (!diffusionModel) return;

    kernel.current?.setModelParams(prevModelParams => {
      const currentParams = prevModelParams[diffusionModel];
      if (!currentParams) return prevModelParams;
      return {
        ...prevModelParams,
        [diffusionModel]: {
          ...currentParams,
          [name]: value,
        }
      };
    });

    kernel.current?.logUserAction('Setting Changed', {
      setting_name: name,
      value_length: value.length,
      model_name: diffusionModel,
      source_component: 'GrokImagineControlPanel'
    });
  }, [kernel]);

  if (!params) return null;

  return (
    <>
      <div className="mb-4">
        <AutoGrowingTextarea
          label="Prompt"
          name="prompt"
          value={params.prompt}
          onChange={handleParamChange}
          onEnterPress={kernel.current?.triggerGenerate}
          maxHeight={600}
          labelClassName="block text-lg font-semibold text-white mb-2"
        />
      </div>
    </>
  );
};

export default memo(GrokImagineControlPanel);

